/* tslint:disable */
/* eslint-disable */
/**
 * Bfree API
 * API Documentation for B&Free Project
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum SupportReportType {
    Altro = 'Altro',
    FunzionamentoApp = 'Funzionamento App',
    Installazione = 'Installazione',
    PianiEGettoni = 'Piani e Gettoni'
}

export function SupportReportTypeFromJSON(json: any): SupportReportType {
    return SupportReportTypeFromJSONTyped(json, false);
}

export function SupportReportTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupportReportType {
    return json as SupportReportType;
}

export function SupportReportTypeToJSON(value?: SupportReportType | null): any {
    return value as any;
}

